// stock.service.js
import axios from "../utils/axios.wrapper";

export const getStocks = async () => {
  const { data } = await axios.get("/stock");
  return data;
};

export const getActiveStocks = async () => {
  const { data } = await axios.get("/stock/active");
  return data.items || data;
};

export const getForSaleStocks = async () => {
  const { data } = await axios.get("/stock/for-sale");
  return data.items || data;
};

export const getInactiveStocks = async () => {
  const { data } = await axios.get("/stock/inactive");
  return data.items || data;
};

export const getStockById = async (id) => {
  const { data } = await axios.get(`/stock/${id}`);
  return data;
};

export const getStocksByProductId = async (productId) => {
  const { data } = await axios.get(`/stock/product/${productId}`);
  return data.items || data;
};

export const getStocksByShopId = async (shopId) => {
  const { data } = await axios.get(`/stock/shop/${shopId}`);
  return data.items || data;
};

export const getForSaleStocksByShopId = async (shopId) => {
  const { data } = await axios.get(`/stock/shop/${shopId}/for-sale`);
  return data.items || data;
};

export const getStocksByInventoryId = async (inventoryId) => {
  const { data } = await axios.get(`/stock/inventory/${inventoryId}`);
  return data.items || data;
};

export const getExpiredStocks = async () => {
  const { data } = await axios.get("/stock/expired");
  return data.items || data;
};

export const getTrashStocks = async () => {
  const { data } = await axios.get("/stock/trash");
  return data.items || data;
};

export const getTransformStocks = async () => {
  const { data } = await axios.get("/stock/transform");
  return data.items || data;
};

export const getStocksExpireInDays = async (days) => {
  const { data } = await axios.get(`/stock/expire-in-days/${days}`);
  return data.items || data;
};

export const getAvailableQuantity = async (shopId, productId) => {
  const { data } = await axios.get(`/stock/available/${shopId}/${productId}`);
  return data;
};

export const getPaginatedActiveStocks = async (filters = {}) => {
  const { data } = await axios.post("/stock/paginate", filters);
  return data;
};

export const validateStockAvailability = async (request) => {
  const { data } = await axios.post("/stock/validate-availability", request);
  return data;
};

export const createStock = async (stock) => {
  const { data } = await axios.post("/stock/create", stock);
  return data;
};

export const createStockRange = async (stocks) => {
  const { data } = await axios.post("/stock/create-range", stocks);
  return data;
};

export const updateStock = async (id, stock) => {
  const { data } = await axios.put(`/stock/${id}`, stock);
  return data;
};

export const deleteStock = async (id) => {
  const { data } = await axios.delete(`/stock/${id}`);
  return data;
};

export const hardDeleteStock = async (id) => {
  const { data } = await axios.delete(`/stock/hard/${id}`);
  return data;
};

export const createStockLine = async (request) => {
  const { data } = await axios.post("/stock/stock-line", request);
  return data;
};

export const processStockMovement = async (request) => {
  const { data } = await axios.post("/stock/movement", request);
  return data;
};

export const saveInventoryRealQuantities = async (inventoryId, lines) => {
  const { data } = await axios.post(
    `/stock/inventory/${inventoryId}/real-quantities`,
    lines
  );
  return data; // { jobId, inventoryId, status, message }
};

export const markStockToDestroy = async (id) => {
  const { data } = await axios.put(`/stock/${id}/to-destroy`);
  return data;
};

export const markStockToDestroyWithQte = async (payload) => {
//  console.log("Stock Service : markStockToDestroyWithQte payload", payload);
  const { data } = await axios.put(`/stock/to-destroy-partial`, payload);
  return data;
};

export const restoreStockFromDestruction = async (id) => {
  const { data } = await axios.put(`/stock/${id}/restore`);
  return data;
};

export const markStockToTransform = async (id, quantity) => {
  const { data } = await axios.put(`/stock/${id}/to-transform`, { quantity });
  return data;
};

export const updateStockDateAndQuantity = async (id, payload) => {
  const { data } = await axios.put(`/stock/${id}/update-date-quantity`, payload);
  return data;
};

export const transformStockProduct = async (id, request) => {
  const { data } = await axios.post(`/stock/${id}/transform-product`, request);
  return data;
};



export const stockService = {
  getStocks,
  getActiveStocks,
  getForSaleStocks,
  getInactiveStocks,
  getStockById,
  getStocksByProductId,
  getStocksByShopId,
  getForSaleStocksByShopId,
  getExpiredStocks,
  getStocksExpireInDays,
  getAvailableQuantity,
  getPaginatedActiveStocks,
  validateStockAvailability,
  createStock,
  createStockRange,
  updateStock,
  deleteStock,
  hardDeleteStock,
  createStockLine,
  processStockMovement,
  getStocksByInventoryId,
  saveInventoryRealQuantities,
  getTrashStocks,
  getTransformStocks,
  markStockToDestroy,
  restoreStockFromDestruction,
  markStockToTransform,
  updateStockDateAndQuantity,
  transformStockProduct,
  markStockToDestroyWithQte,
};